 export const formatDateTime = (date) => {
  const d = new Date(date);

  const day = d.getDate();

  // 👇 ordinal (st, nd, rd, th)
  const getOrdinal = (n) => {
    if (n > 3 && n < 21) return "th";
    switch (n % 10) {
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return "th";
    }
  };

  const dayWithSuffix = `${day}${getOrdinal(day)}`;

  const month = d.toLocaleString("en-US", { month: "long" });
  const year = d.getFullYear();

  const time = d.toLocaleString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  return `${dayWithSuffix} ${month} ${year}, ${time}`;
};